import { useCallback, useEffect, useRef } from 'react';

// useDialogClickOutside - 本地實作
// 使用 onMouseDown 而非 onClick，防止在視窗內點擊拖動到視窗外時誤觸關閉
export const useDialogClickOutside = (onClose: () => void) => {
  const handleBackgroundMouseDown = useCallback((e: React.MouseEvent) => {
    // 只有在背景元素本身上按下滑鼠時才關閉
    if (e.target === e.currentTarget) {
      onClose();
    }
  }, [onClose]);

  return handleBackgroundMouseDown;
};

// useModalScrollLock - 本地實作
export const useModalScrollLock = (isOpen: boolean) => {
  const modalRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (isOpen) {
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';

      const findModalContent = () => {
        const modals = document.querySelectorAll('[role="dialog"], .modal, .fixed.inset-0');
        for (let i = 0; i < modals.length; i++) {
          const modal = modals[i];
          const scrollable = modal.querySelector('.overflow-y-auto, .overflow-auto, .scrollable');
          if (scrollable) {
            modalRef.current = scrollable as HTMLElement;
            return;
          }
          if (modal.scrollHeight > modal.clientHeight) {
            modalRef.current = modal as HTMLElement;
            return;
          }
        }
      };

      const handleWheel = (e: WheelEvent) => {
        const target = e.target as Element;
        const isInsideScrollable = (element: Element): boolean => {
          if (!element || element === document.body) return false;
          const styles = getComputedStyle(element);
          const hasScroll = styles.overflowY === 'auto' || styles.overflowY === 'scroll' ||
                           styles.overflow === 'auto' || styles.overflow === 'scroll';
          const canScroll = element.scrollHeight > element.clientHeight;
          if (hasScroll && canScroll) return true;
          return isInsideScrollable(element.parentElement!);
        };

        if (isInsideScrollable(target)) return;
        e.preventDefault();
        if (!modalRef.current) findModalContent();
        if (modalRef.current) modalRef.current.scrollTop += e.deltaY;
      };

      setTimeout(findModalContent, 100);
      document.addEventListener('wheel', handleWheel, { passive: false });

      return () => {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.overflow = '';
        window.scrollTo(0, scrollY);
        document.removeEventListener('wheel', handleWheel);
        modalRef.current = null;
      };
    }
  }, [isOpen]);
};

export * from './useFormSubmit';
export * from './useInvoiceLimitCache';
